import { all, takeEvery, put, call } from 'redux-saga/effects';
import actions from './actions';
import { axiosPrivate } from '../../Helpers/axios';
import { maskNumber } from '../../utils/maskMobileNum';


function* getTransactionsDataResponse({ payload: { agentId ,  page, limit, search, fromDate, toDate , status} }) {
  try
  {

     const response = yield call(
        axiosPrivate.get,
        `/api/cou-dashboard/transactions?page=${page ? page : 1}&limit=${limit ? limit : 100}${search ? `&search=${encodeURIComponent(search)}` : ''}${fromDate ? `&fromDate=${encodeURIComponent(fromDate)}` : ''}${toDate ? `&toDate=${encodeURIComponent(toDate)}` : ''}${agentId ? `&agentId=${agentId}` : ""}${status ? `&status=${status}` : ''}`
      );

    //  const response = yield call(
    //     axios.get,
    //     `http://localhost:7070/api/cou-dashboard/transactions?page=${page ? page : 1}&limit=${limit ? limit : 10}${search ? `&search=${search}` : ''}${fromDate ? `&fromDate=${encodeURIComponent(fromDate)}` : ''}${toDate ? `&toDate=${encodeURIComponent(toDate)}` : ''}${agentId ? `&agentId=${agentId}` : ""}${status ? `&status=${status}` : ''}`
    //   );
    if (response.status === 200) {
      yield put(actions.getTransactionsDataSuccess(response?.data, response?.data?.total));
    } else {
      yield put(actions.getTransactionsDataFailed(response?.message));
    }
  } catch (error) {
    yield put(actions.getTransactionsDataFailed(error?.response?.data?.message));
  }
}


function* getAllTransactionsDataResponse({ payload: { offset, limit, search, fromDate, toDate,agentId , status} }) {
  try {
    const response = yield call(axiosPrivate, `/api/cou-dashboard/transactions?page=${offset ? offset : 1}&limit=${limit ? limit : 100}${search ? `&search=${search} ` : ''}${fromDate ? `&fromDate=${fromDate} ` : ''}${toDate ? `&toDate=${toDate} ` : ''}${agentId ? `&agentId=${agentId}` : ""}`);
    if (response.status === 200) {
      yield put(actions.getAllTransactionsDataSuccess(response?.data, response?.data?.total));
    } else {
      yield put(actions.getAllTransactionsDataFailed(response?.message));
    }
  } catch (error) {
    yield put(actions.getAllTransactionsDataFailed(error?.response?.data?.message||error));
  }
}

function* getChartDataResponse({payload:{agentId}}) {
  try {
    const response = yield call(axiosPrivate, `/api/cou-dashboard/transactions/graph?${agentId ? `agentId=${agentId}` : ""}`);
      yield put(actions.getChartDataSuccess(response?.data));
  } catch (error) {
    yield put(actions.getChartDataFailed(error?.response?.data?.message));
  }
}


function* getDailyChartDataResponse({payload:{agentId}}) {
  try {
    const response = yield call(axiosPrivate, `/api/cou-dashboard/transactions/daily-graph?${agentId ? `agentId=${agentId}` : ""}`);
      yield put(actions.getDailyChartDataSuccess(response?.data));
  } catch (error) {
    yield put(actions.getDailyChartDataFailed(error?.response?.data?.message));
  }
}

function* getPieChartDataResponse({payload:{agentId}}) {
  try {
    const response = yield call(axiosPrivate, `/api/cou-dashboard/transactions/piechart?${agentId ? `agentId=${agentId}` : ""}`);
      yield put(actions.getPieChartDataSuccess(response?.data));
  } catch (error) {
    yield put(actions.getPieChartDataFailed(error?.response?.data?.message));
  }
}



function* getFullTransactionDetails({payload:{refId}}){
  try {
    const response = yield call(axiosPrivate, `/api/cou-dashboard/transactions/full-transaction-history/${refId}`);
    if(response.status===201||response.status===200){
      response.data.request.customerMobile = maskNumber(response.data.request.customerMobile)
      yield put(actions.getFullTransactionsDetailsSuccess(response?.data))
    }else {
      yield put(actions.getFullTransactionDetailsError(response))
    }
  } catch (error) {
      yield put(actions.getFullTransactionDetailsError(error))
  }
}

function* getLogger({ payload: { page, limit, search, fromDate, toDate } }) {
  try {
    //console.log("bug", page, limit, search, fromDate, toDate);
    let url = `/cou-dashboard/logger/logs?page=${page || 1}&limit=${limit || 10}`;
    
    if (search) {
      url += `&search=${search}`;
    }
    if (fromDate) {
      url += `&fromDate=${encodeURIComponent(fromDate)}`;
    }
    if (toDate) {
      url += `&toDate=${encodeURIComponent(toDate)}`;
    }

    //console.log("🔍 Final API URL:", url);
    
    const response = yield call(axiosPrivate, url);
    //console.log("🔍 API Response:", response?.data);
    if (response.status === 201 || response.status === 200) {
      yield put(actions.getLoggerDataSuccess(response?.data));
    } else {
      yield put(actions.getLoggerDataFailed(response));
    }
  } catch (error) {
    //console.log("🔍 API Error:", error);
    yield put(actions.getLoggerDataFailed(error));
  }
}




export default function* rootSaga() {
  yield all([takeEvery(actions.GET_TRANSACTIONS_DATA, getTransactionsDataResponse)]);
  yield all([takeEvery(actions.GET_ALL_TRANSACTIONS_DATA, getAllTransactionsDataResponse)]);
  yield all([takeEvery(actions.GET_CHART_DATA, getChartDataResponse)]);
  yield all([takeEvery(actions.GET_DAILY_CHART_DATA, getDailyChartDataResponse)]);
  yield all([takeEvery(actions.GET_FULL_TRANSACTIONS_DETAILS, getFullTransactionDetails)]);
  yield all([takeEvery(actions.GET_PIE_CHART_DATA, getPieChartDataResponse)]);
  yield all([takeEvery(actions.GET_LOGGER_DATA, getLogger)]);
  yield all([takeEvery(actions.GET_PIE_CHART_DATA, getPieChartDataResponse)]);
}
